import { render } from "./CoManagerDashboard.vue?vue&type=template&id=2b13a2f6&scoped=true"
import script from "./CoManagerDashboard.vue?vue&type=script&lang=js"
export * from "./CoManagerDashboard.vue?vue&type=script&lang=js"

import "./CoManagerDashboard.vue?vue&type=style&index=0&id=2b13a2f6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b13a2f6"]])

export default __exports__